import { Card } from "@/components/ui/card";
import CreditsTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";

const Credits = () => {
  useDocumentTitle("Credit");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <CreditsTableView />
      </Card>
    </div>
  );
};

export default Credits;
